import {AfterViewInit, Component, ElementRef, HostListener, OnInit, ViewChild} from '@angular/core';
import {BaseOverlayDialogComponent} from '../base-overlay-dialog/base-overlay-dialog';

@Component({
  selector: 'app-report-problem-dialog',
  templateUrl: './report-problem-dialog.component.html',
  styleUrls: ['./report-problem-dialog.component.scss']
})
export class ReportProblemDialogComponent extends BaseOverlayDialogComponent implements OnInit, AfterViewInit {
  public loading = true;
  public dialogHidden = true;

  public message = '';

  buttonAction: () => void;

  closeAction: () => void;

  ngOnInit() {
  }

  ngAfterViewInit() {
  }

  public async initData() {

    this.loading = true;

    this.loading = false;

  }

  @HostListener('document:keydown', ['$event']) onKeydownHandler(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      event.preventDefault();
      this.clickedButton();
    }
  }

  setupButton(action: () => void) {
    this.buttonAction = action;
  }

  setupCloseButton(action: () => void) {
    this.closeAction = action;
  }

  clickedButton() {
    if (this.buttonAction) {
      this.buttonAction();
    }
    this.close();
  }

  getHideDuration(): number {
    return 0;
  }

  getShowDuration(): number {
    return 0;
  }

  closeDialog(e: Event) {
    e.preventDefault();
    this.hide();
    if (this.closeAction) {
      this.closeAction();
    }
    this.close();
  }

  hide() {
    setTimeout(
      () => {
        this.dialogHidden = true;
      },
      50
    );
  }

  show() {
    this.initData()
      .then(() => {
        this.dialogHidden = false;
      })
  }

}
